import { useRef } from 'react';

import ArrowIcon from '~/assets/icons/Arrow';
import useHasScrolledPast from '~/hooks/useHasScrolledPast';

export default function NotificationTooltip({
  className
}: {
  className?: string;
}) {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const hasScrolledPast = useHasScrolledPast(tooltipRef);

  return (
    <div ref={tooltipRef} className="w-full md:w-[254px]">
      {hasScrolledPast && (
        <div
          className={`flex h-8 items-center justify-between bg-white/90 bg-[linear-gradient(0deg,_rgba(209,_159,_244,_0.16)_0%,_rgba(209,_159,_244,_0.16)_100%)] px-2 py-1.5 md:pr-4 ${className} animate-slide-delay opacity-0`}
        >
          <div className="text-xs leading-5 text-purple-hola">
            Tap the bell to get a release alert
          </div>
          <div className="rotate-270">
            <ArrowIcon fill="#8907e7" className="animate-pulse" />
          </div>
        </div>
      )}
    </div>
  );
}
